module.exports = __webpack_public_path__ + "img/madera010.e84729a7.jpg";